<template>
  <header class="marketing-sms-header">
    <button class="btn btn-round btn-primary"
            @click="showCreateTypeModal">{{$t('message.sms.message.createSms')}}</button>

    <div class="marketing-sms-header-tabs">
      <tab-selector v-model="tab"
                    :data-tabs="tabs"
                    @input="emitTab"></tab-selector>
    </div>

    <app-search-bar class="marketing-sms-header-search"
                    v-model="search"
                    @enter="emitMarketingSearch" />

    <i v-if="!isPartnerLoggedAs"
        v-tooltip="$t('message.marketingGenerics.message.creditHistory')"
        class="mdi mdi-file-document-outline pointer marketing-sms-header-list"
        @click="openCreditsList"></i>

    <marketing-credits-modal v-model="showCreditsModal"
                             channel-type="SMS" />

    <marketing-create-modal-type v-model="showingCreateTypeModal"
                                 @nextStep="goToNextCreationStep" />

    <marketing-sms-create-modal-automation v-model="showingAutomationModal"
                                           :title="smsTitle"
                                           @created="emitSmsCreated" />
  </header>
</template>

<script>
import TabSelector from "@components/TabSelector";
import MarketingCreditsModal from "@components/modules/marketing/generic/credits/modal/MarketingCreditsModal";
import MarketingCreateModalType from "@components/modules/marketing/generic/create/modal/type/MarketingCreateModalType";
import MarketingSmsCreateModalAutomation from "@components/modules/marketing/sms/generic/create/modal/automation/MarketingSmsCreateModalAutomation";
import EventBus from "@packages/event-bus";
import AppSearchBar from "@components/Search";

export default {
  components: {
    AppSearchBar,
    MarketingCreditsModal,
    MarketingCreateModalType,
    MarketingSmsCreateModalAutomation,
    TabSelector,
  },

  computed: {
    user() {
      return this.$store.state.users.user;
    },    
    isPartnerLoggedAs() {
      return this.$store.state.users.parceiro;
    },
    tabs() {
        return [
            {
                label: this.$t('message.marketingGenerics.message.singleSend'),
                value: false,
            },

            {
                label: this.$t('message.marketingGenerics.message.automation'),
                value: true,
            },
        ]
    }
  },

  data() {
    return {
      step: 0,
      search: "",
      showCreditsModal: false,
      showingCreateTypeModal: false,
      showingAutomationModal: false,
      smsTitle: undefined,
      tab: undefined,
    };
  },

  methods: {
    emitMarketingSearch() {
      EventBus.$emit("SMS_SET_SEARCH", this.search);
    },
    openCreditsList() {
      this.showCreditsModal = true;
    },
    hideCreditsList() {
      this.showCreditsModal = false;
    },
    showCreateTypeModal() {
      this.showingCreateTypeModal = true;
    },
    goToNextCreationStep({ isAutomationFlow, title }) {
      if (isAutomationFlow) {
        this.smsTitle = title;
        this.showingCreateTypeModal = false;
        this.showingAutomationModal = true;
      } else {
        this.$router.push({
          path: "/marketing/sms/criar",
          query: {
            title,
          },
        });
      }
    },
    emitTab(value) {
      EventBus.$emit("SET_SMS_LIST_TAB", value);
    },
    emitSmsCreated() {
      EventBus.$emit("SMS_CREATED");
    },
  },
};
</script>

<style lang="scss" scoped>
.marketing-sms-header {
  display: flex;
  align-items: center;

  .marketing-sms-header-list {
    font-size: 25px;
    color: #707070;
  }

  .marketing-sms-header-tabs {
    width: 400px;
    margin: 0 auto;
    font-weight: 600;
  }

  .marketing-sms-header-search {
    flex: 0;
    min-width: 200px;
    margin-right: 40px !important;
    padding-top: 0 !important;
  }
}
</style>

